const EMOJI =
  /[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}\u{200D}\u{1F1E6}-\u{1F1FF}]/gu;

export function sanitizeHubText(value) {
  return String(value || "")
    .replace(/<[^>]*>/g, "")
    .replace(/!\[[^\]]*]\([^)]*\)/g, "")
    .replace(/\bhttps?:\/\/\S+\.(?:png|jpe?g|gif|webp|svg)\b/gi, "")
    .replace(EMOJI, "")
    .replace(/\s+\n/g, "\n")
    .trim();
}

export function escapeHtml(value) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/** Light formatting only: **bold**, *italic*, line breaks. */
/** Open the venue in a map using street address or venue name. */
export function venueMapsUrl(addressOrPlace) {
  const q = String(addressOrPlace || "").trim();
  if (!q) return "";
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
}

export function hubContactLooksPlaceholder(contact) {
  return /\b555[\-.) ]|\(xxx\)/i.test(String(contact || ""));
}

export function hubListingPhoneLooksValid(phone) {
  const text = String(phone || "").trim();
  if (!text || hubContactLooksPlaceholder(text)) return false;
  const digits = text.replace(/\D/g, "");
  return digits.length >= 10;
}

/** Phone segment from a combined contact line (legacy storage). */
export function hubListingPhoneFromContact(contact) {
  const formatted = formatHubListingContact(contact);
  for (const part of formatted.split("·")) {
    const piece = part.trim();
    if (hubListingPhoneLooksValid(piece)) return piece;
  }
  return "";
}

/** Desk name or email — not the phone segment. */
export function formatHubListingContactLabel(contact) {
  return formatHubListingContact(contact)
    .split("·")
    .map((part) => part.trim())
    .filter((part) => part && !hubListingPhoneLooksValid(part))
    .join(" · ");
}

export function hubPhoneTelHref(phone) {
  const digits = String(phone || "").replace(/\D/g, "");
  if (digits.length < 10) return "";
  const national = digits.length === 10 ? digits : digits.slice(-10);
  return `tel:+1${national}`;
}

/** Drop placeholder demo emails and fake 555 numbers; keep real desk names and phones. */
export function formatHubListingContact(contact) {
  return String(contact || "")
    .split("·")
    .map((part) => part.trim())
    .filter((part) => {
      if (!part) return false;
      if (part.includes("@") && /\.example\b/i.test(part)) return false;
      if (/\b555[\-.) ]|\(xxx\)/i.test(part)) return false;
      return true;
    })
    .join(" · ");
}

/** YYYY-MM-DD listing stamp → readable date for cards. */
export function formatHubListingDate(stamp) {
  if (!stamp) return "";
  const [year, month, day] = String(stamp).split("-").map(Number);
  const date = new Date(year, (month || 1) - 1, day || 1);
  if (Number.isNaN(date.getTime())) return String(stamp);
  return date.toLocaleDateString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function formatHubHtml(value) {
  const safe = escapeHtml(sanitizeHubText(value));
  const withBold = safe.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
  const withItalic = withBold.replace(/(^|[^*])\*([^*]+)\*/g, "$1<em>$2</em>");
  return withItalic.replace(/\n/g, "<br />");
}
